import axios from "axios";

export const findAllCategories = () => {
  return axios.get(`${process.env.REACT_APP_URL}/getallcategories`, {
    withCredentials: true,
  });
};
